export default "__VITE_ASSET__CmNtP$pA__"